<mode-alert-banner *ngIf="toggleOffConfirmationAlert" [message]="toggleOffConfirmationAlert">
  <button
    class="secondary-button alert-action-button"
    secondary-button
    (click)="clearAlert()">
    Cancel
  </button>
  <button
    class="primary-button alert-action-button"
    primary-button
    (click)="confirmTurnOff()">
    Turn Off
  </button>
</mode-alert-banner>
<section class="section external-sharing"
  [class.section-disabled]="disabled"
  [class.external-sharing-highlighted]="sharing"
  capraTooltip
  tooltipPlacement="bottom"
  [tooltipIsDisabled]="!disabled"
  [tooltipContent]="tooltipMessage"
  [tooltipOffset]="tooltipOffset"
>
  <h3 class="header">
    External Sharing
  </h3>
  <div class="content">
    <p>
      Make the URL for this Report public. Anyone the link is shared<br>
      with can view the Report's contents and drilldown into data.
    </p>
    <div class="toggle">
      <h6 class="toggle-label"
        data-test="toggle-label"
      >
        {{ sharing ? 'On' : 'Off' }}
      </h6>
      <mode-toggle-switch class="toggle-switch"
      offIcon="icon-lock"
      [disabled]="disabled"
      [state]="sharing"
      [analyticsData]="sharing ? externalSharingToggleOffPayload : externalSharingToggleOnPayload"
      (stateChange)="onStateChange($event)"
      capraTooltip
      [tooltipContent]="externalSharingToggleMessage"
      tooltipPlacement="bottom"
      [tooltipIsDisabled]="disabled"
    ></mode-toggle-switch>
    </div>
  </div>
</section>
